import { Component, OnInit } from '@angular/core';

import { Combustivel } from "../shared/combustivel.model";
import { combustiveisModuleName } from "../shared/data.service";
import { CombustivelApiService } from "../shared/combustivel-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { CombustivelNavigationService } from "../shared/combustivel-navigation.service";
import { CombustivelService } from "../shared/combustivel.service";
import { abastecimentosRoute, abastecimentosModuleName } from "../../shared/data.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import { configuracaoModuleName } from "../../../shared/services/data.service";

@Component({
    template: require('./combustivel-list.component.html'),
    styles: [require('./combustivel-list.component.css')]
})
export class CombustivelListComponent implements OnInit {
    list: Combustivel[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    combustiveisModuleName: any = combustiveisModuleName;
    abastecimentosRoute: string = abastecimentosRoute;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _combustiveisApiService: CombustivelApiService,
        private _combustivelService: CombustivelService,
        private _combustivelNavigationService: CombustivelNavigationService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._combustivelService.clearSessionStorage();
        this._combustivelNavigationService.goToNew();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickEdit(item: Combustivel) {
        this._combustivelService.clearSessionStorage();
        this._combustivelNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Combustivel) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._combustiveisApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._combustiveisApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/combustivel-list/combustivel-list.component.ts
 **/